import { useTranslation } from 'next-i18next'
import PluginClearFilter from './PluginClearFilter'

export default function PluginsFilterRating ({ onCheckedRatingChange, checkedRating, plugins }) {
  const { t } = useTranslation('plugins')
  const ratings = [4, 3, 2, 1]

  const ratingInputs = ratings.map((value) => (
    <div
      className="form-check mt-2"
      key={value}
    >
      <input
        className="form-check-input"
        type="radio"
        name="rating"
        value={value}
        id={`rating${value}`}
        checked={value === checkedRating}
        onChange={() => onCheckedRatingChange(value)}
      />
      <label
        className="form-check-label"
        htmlFor={`rating${value}`}
      >
        {t(`browse_all.filter.rating${value}`)}
      </label>
      {
        value !== checkedRating && (
          <span className="badge rounded-pill text-bg-primary badge-sm ms-3">
            {/* We add + 1 one to value here because the filter says: "X and more" */}
            {
              plugins.meta?.facets?.rating?.buckets?.find(bucket => bucket.key === value || bucket.key === value + 1)?.doc_count || 0
            }
          </span>
        )
      }
    </div>
  ))

  return (
    <div>
      <button
        className="text-dark col-auto filter-bar__heading w-100 btn d-flex align-items-center justify-content-between fw-bold px-0"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseRating"
        aria-expanded="false"
        aria-controls="collapseRating"
      >
        <span>
          {t('browse_all.filter.rating', { ns: 'plugins' })}
        </span>
        <svg
          viewBox="0 0 10 10"
          xmlns="http://www.w3.org/2000/svg"
          height="14"
          width="14"
        >
          <path
            d="M.5,2.75,4.646,7.1a.5.5,0,0,0,.708,0L9.5,2.75"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </svg>
      </button>
      <div
        className="collapse"
        id="collapseRating"
      >
        {ratingInputs}
        {checkedRating > 0 && (<PluginClearFilter callback={() => onCheckedRatingChange(0)} />)}
      </div>
    </div>
  )
}
